import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class SchoolGroupService {
	constructor(private httpclientService: HttpclientService) {}
	loadSchoolGroupList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/SchoolGroupGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MTAStatsChartSchoolGroupGetList(ApplicationItemID, SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/MTAStatsChartSchoolGroupGetList?ApplicationItemID=" + ApplicationItemID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
